import { render } from "./Admins.vue?vue&type=template&id=bcb8f90a&scoped=true"
import script from "./Admins.vue?vue&type=script&lang=js"
export * from "./Admins.vue?vue&type=script&lang=js"

import "./Admins.vue?vue&type=style&index=0&id=bcb8f90a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\projects\\SwitchQ-Websockets\\websockets-manager-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb8f90a"]])

export default __exports__